import ConfirmationPanel from 'components/form/confirmation/confirmation-panel';
import React from 'react';
import Validation from 'components/form/validation/validation';
import { Controller, useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import { nameOfFactory } from 'utils/types-util';
import { ReactSelect } from 'components/form/field/react-select';
import { NumberOption } from 'interfaces/forms/types';
import { useTypedSelector } from 'hooks/use-typed-selector';
import { LicensedStatesTypeFormStyles } from './licensed-states-form.styles';
import { IFormFields } from './types';

type RolesTypeFormFields = IFormFields<NumberOption>;

interface IRolesFormProps extends WithStyles<typeof LicensedStatesTypeFormStyles> {
  initialValue: string;
  handleCancel: () => void;
  handleSubmit: (value: number) => void;
}

const getFieldName = nameOfFactory<RolesTypeFormFields>();

const RolesForm: React.FC<IRolesFormProps> = (props: IRolesFormProps): JSX.Element => {
  const { classes } = props;

  // #region component state
  const {
    handleSubmit,
    control,
    setError,

    formState: { errors },
  } = useForm<any>();
  const roles = useTypedSelector(state => state.lookups.roles);

  const options = React.useMemo<NumberOption[]>(() => {
    return roles.map<NumberOption>(role => {
      return {
        label: role.display_name,
        value: role.id,
      };
    });
  }, [roles]);
  // #endregion

  // #region helpers
  const onSubmit = (formValues: RolesTypeFormFields) => {
    if (!formValues.selectedValue) {
      setError(getFieldName('selectedValue'), { type: 'manual' });
    } else {
      props.handleSubmit(formValues.selectedValue.value);
    }
  };

  const onCancel = () => {
    props.handleCancel();
  };

  const getDefaultValue = (): NumberOption | null => {
    return options.find(x => String(x.value) === String(props.initialValue)) || null;
  };
  // #endregion

  return (
    <Grid container direction="column" className={classes.container}>
      <Grid item>
        <form>
          <Controller
            control={control}
            name={getFieldName('selectedValue')}
            rules={{ required: true }}
            defaultValue={getDefaultValue()}
            render={(fieldProps: any) => (
              <>
                <ReactSelect
                  name={getFieldName('selectedValue')}
                  value={fieldProps?.field?.value}
                  fields={options}
                  menuPosition="relative"
                  handleOnChange={fieldProps?.field?.onChange}
                  isMulti={false}
                />
                <Validation touched={errors.selectedValue} error="Required" />
              </>
            )}
          />
        </form>
      </Grid>
      <Grid item>
        <ConfirmationPanel
          handleSubmit={handleSubmit(onSubmit)}
          handleCancel={() => {
            onCancel();
          }}
        />
      </Grid>
    </Grid>
  );
};

export const RolesFormStyled = withStyles(LicensedStatesTypeFormStyles)(RolesForm);
